// extracted by mini-css-extract-plugin
export default {"loadingContainer":"jLlezlKtf0Egmn237PGR","buttonGroup":"MwdaF7xpffrChSWxySem","adminBox":"p6Bu6sS46gKzvvoLHz58","taxNotice":"gzE6vObBPCrIXSOUJLLH"};